module.exports = __webpack_public_path__ + "media/music/b6a8e4a96ffcd83154ad2c5cbcb52751.mp3";